import React, {PureComponent} from 'react';

import { Classes, Intent, Tooltip } from "@blueprintjs/core";

const INTENTS = [Intent.NONE, Intent.PRIMARY, Intent.SUCCESS, Intent.DANGER, Intent.WARNING];

export default class InfoCircle extends PureComponent{
    render(){
        return(
            <Tooltip className={Classes.TOOLTIP_INDICATOR} content={this.props.infoCircleContent}>
                {this.props.icon === 'question' ?
                    <i className="far fa-question-circle" ></i>
                    :
                    this.props.icon === 'question-grey' ?
                        <i className="far fa-question-circle" style={{color: '#D6DBDF'}}></i>
                        :
                        <span className="fas fa-info-circle"></span>
                }
            </Tooltip>
        )
    }
}